import { FormattedMessage, useIntl } from 'react-intl';
import { Card, ListGroup } from 'react-bootstrap';

const formatDate = (date: Date) => {

    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();

    return `${mm}-${dd}-${yyyy}`;

};

// ScopeId for a Testing Center in the new reports engine (see reports/utils/scopePolicy.ts).
// Omitting ScopeObjectId makes the reports page open the Testing Center picker on arrival,
// matching the legacy repState=TC / PType=4 behavior.
const TESTING_CENTER_SCOPE_ID = 4;

// The legacy Course Usage Report exposed three variants via the CUR filter type
// (0 = Enrollment, 3 = Completion, 2 = Activity). Map each dashboard tile to its
// migrated React report id here.
// TODO: replace the 0 placeholders with the real report ids from the report catalog
// (Admin_Reports_GetReports). If all three are a single migrated report distinguished by
// a filter, point them at the same id and append that filter as an extra query param below.
const REPORT_IDS: Record<number, number> = {
    0: 0, // Enrollment
    2: 0, // Activity
    3: 0 // Completion
};

const buildReportUrl = (curType: number) => {

    const today = new Date();
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(today.getDate() - 30);

    const params = new URLSearchParams({
        ScopeId: String(TESTING_CENTER_SCOPE_ID),
        StartEndDate: `${formatDate(thirtyDaysAgo)}|${formatDate(today)}`
    });

    return `/reports/${REPORT_IDS[curType]}?${params.toString()}`;

};

export const QuickReportsTile = () => {

    const { formatMessage } = useIntl();

    const reports = [
        { curType: 0, label: formatMessage({ id: 'enrollment_report_last_30_days.a3cfbe60', defaultMessage: 'Enrollment Report (Last 30 days)' }) },
        { curType: 3, label: formatMessage({ id: 'completion_report_last_30_days.2c9d124c', defaultMessage: 'Completion Report (Last 30 days)' }) },
        { curType: 2, label: formatMessage({ id: 'activity_report_last_30_days.2622356c', defaultMessage: 'Activity Report (Last 30 days)' }) }
    ];

    return (
        <Card>
            <Card.Header className="text-uppercase">
                <strong>
                    {<FormattedMessage defaultMessage="Quick Reports" id="quick_reports.d69d8ca5" />}
                </strong>
            </Card.Header>
            <ListGroup variant="flush">
                {reports.map(report => (
                    <ListGroup.Item
                        action
                        active={false}
                        href={buildReportUrl(report.curType)}
                        key={report.curType}
                        rel="noreferrer"
                        target="_blank"
                    >
                        <i className="fa-solid fa-file-chart-line me-2 text-muted" />
                        {report.label}
                    </ListGroup.Item>
                ))}
                <ListGroup.Item
                    action
                    active={false}
                    href="/reports"
                >
                    <i className="fa-solid fa-file-chart-line me-2 text-muted" />
                    <FormattedMessage defaultMessage="New Manual Report" id="new_manual_report.f358b18e" />
                </ListGroup.Item>
            </ListGroup>
        </Card>
    );

};
